const customPopups = () => {
  const product = CPB.getStore().getState().Product;
  let categories = {};

  const styles = "#product-builder .cpb-theme-provider.aloha .cpb-layout:not(.cpb-is-admin) .cpb-category-title{display:flex;justify-content:space-between;flex-wrap:wrap;padding-inline-end:1rem;gap:1rem;}.cpb-custom-show-discr-button{text-transform:none;text-decoration: underline;}.custom-decr {background-color: white;border-radius: 0;border: 2px solid gray;}.custom-decr h2, .custom-decr .swal2-html-container {text-align: start;color: black;padding-inline-start: 2rem;}.custom-decr h2{text-decoration:underline;font-size:2rem;}div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm{background-color: #C2B9C7;display: none !important;}div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm:focus{box-shadow: 0 0 0 3px #c2b9af70;}";
  const styleElem = document.createElement('style');
  styleElem.textContent = styles;
  

  product.panels.forEach(panel => {
    panel.categories.forEach(category => {
      if (category.description) {
        categories[category.id] = category.description;      
      }
    });
  });

  const initPopups = () => {
    for (const id in categories) {
      const categoryElement = document.querySelector(`[data-category-id="${id}"]`);
      if (!categoryElement) continue
      const title = categoryElement.querySelector('.cpb-category-title');

      if (!title.querySelector('.cpb-custom-show-discr-button')) {
        const btn = document.createElement('span');
        btn.classList.add('cpb-custom-show-discr-button');
        btn.textContent = 'En savoir plus';
        btn.addEventListener('click', () => {
          Swal.fire({
            html: categories[id],
            title: 'En savoir plus',
            showClass: {
                popup: 'custom-decr'
            },
            showCloseButton: 'true'
          });
        });

        title.append(btn); 
      }
    } 
  };

  document.body.append(styleElem);
  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', initPopups);
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
    setTimeout(() => {
      initPopups();
    }, 50)
  });
  initPopups();
}

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  customPopups();
})